import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { OauthCallbackComponent } from './core/oauth-callback/oauth-callback.component';
import { LandingPageComponent } from './core/permissions/landing-page.component';
import { SecurityGuard } from './core/permissions/security.guard.service';
import { DealerStockListPageComponent } from './modules/dealer-stock/dealer-stock-list-page.component';
import { DocumentsSearchComponent } from './modules/documents-search/documents-search.component';
import { SparePartsComponent } from './modules/spare-parts/spare-parts.component';
import { UnauthorizeComponent } from './modules/unauthorize-page/unauthorize-page.component';

const routes: Routes = [
  // Callback OAuth sin guard — MsalRedirectComponent (bootstrap) procesa el código
  { path: 'redirect', component: OauthCallbackComponent },
  { path: 'login-failed', component: UnauthorizeComponent },
  { path: 'unauthorize', component: UnauthorizeComponent },

  // Rutas protegidas — MsalGuard igual que DLRA
  { path: '', component: LandingPageComponent, canActivate: [MsalGuard] },
  {
    path: 'dealer-stock-list',
    component: DealerStockListPageComponent,
    canActivate: [MsalGuard, SecurityGuard],
    data: { role: 'FDP01001' },
  },
  {
    path: 'documents-search',
    component: DocumentsSearchComponent,
    canActivate: [MsalGuard, SecurityGuard],
    data: { role: 'FDD00044' },
  },
  {
    path: 'spare-parts',
    component: SparePartsComponent,
    canActivate: [MsalGuard, SecurityGuard],
    data: { role: 'FDI00003' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledBlocking' : 'disabled'
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
